import { ElementRef, OnInit } from '@angular/core';
var ProductCarouselComponent = /** @class */ (function () {
    function ProductCarouselComponent(el) {
        this.el = el;
        this.vwValue = 0;
        this.scrolledTo = 0;
        this.visibleCarouselItems = 4;
    }
    ProductCarouselComponent.prototype.ngOnInit = function () {
        this.calculateContainerWidth();
    };
    Object.defineProperty(ProductCarouselComponent.prototype, "packs", {
        get: function () {
            return this._packs;
        },
        set: function (value) {
            this._packs = value;
        },
        enumerable: true,
        configurable: true
    });
    ProductCarouselComponent.prototype.calculateContainerWidth = function () {
        this.containerWidth = ((this._packs.length * 25) - 6) + 'vw';
    };
    ProductCarouselComponent.prototype.resetCarouselScrolling = function () {
        this.vwValue = 0;
        this.scrolledTo = 0;
        this.currentlyActiveItem = null;
        this.toggleState();
    };
    ProductCarouselComponent.prototype.resetCarouselScrolling1 = function () {
        this.scrolledTo = this._packs.length - this.visibleCarouselItems;
        this.vwValue = this.scrolledTo * ProductCarouselComponent.RIGHT;
        this.currentlyActiveItem = null;
        this.toggleState();
    };
    ProductCarouselComponent.prototype.activateCarouselScrolling = function (activatedItem) {
        var scrollDirection = this.determineDirection(activatedItem);
        var indexToScrollTo = this.calculateIndexToScrollTo(scrollDirection, activatedItem.x);
        if (indexToScrollTo !== this.scrolledTo) {
            this.scrolledTo = indexToScrollTo;
            this.scroll(scrollDirection);
        }
    };
    ProductCarouselComponent.prototype.scrollToSelectedPack = function (activatedItem) {
        this.activateCarouselScrolling(activatedItem);
        this.currentlyActiveItem = activatedItem;
        if (activatedItem.x === 0) {
            this.resetCarouselScrolling();
        }
        if (this._packs.length >= this.visibleCarouselItems && activatedItem.x === this._packs.length - 1) {
            this.resetCarouselScrolling1();
        }
    };
    ProductCarouselComponent.prototype.scroll = function (vw) {
        this.vwValue += vw;
        this.toggleState();
    };
    ProductCarouselComponent.prototype.determineDirection = function (activatedItem) {
        var currentActiveIndex;
        if (this.currentlyActiveItem) {
            currentActiveIndex = this.currentlyActiveItem.x;
        }
        else {
            currentActiveIndex = 0;
        }
        if (activatedItem.x > currentActiveIndex) {
            return ProductCarouselComponent.RIGHT;
        }
        else if (activatedItem.x < currentActiveIndex) {
            return ProductCarouselComponent.LEFT;
        }
        else {
            return null;
        }
    };
    ProductCarouselComponent.prototype.calculateIndexToScrollTo = function (scrollDirection, selectedProductIndex) {
        var indexToScrollTo = selectedProductIndex;
        if (scrollDirection === ProductCarouselComponent.RIGHT) {
            if (this.scrolledTo + this.visibleCarouselItems > indexToScrollTo) {
                indexToScrollTo = this.scrolledTo;
            }
            if (this.scrolledTo + this.visibleCarouselItems === indexToScrollTo) {
                indexToScrollTo = this.scrolledTo + 1;
            }
        }
        else {
            if (this.scrolledTo < indexToScrollTo) {
                indexToScrollTo = this.scrolledTo;
            }
        }
        return indexToScrollTo;
    };
    ProductCarouselComponent.prototype.toggleState = function () {
        this.el.nativeElement.querySelector('div').style.transform = 'translate3d(' + this.vwValue + 'vw, 0, 0)';
    };
    ProductCarouselComponent.LEFT = 23.75;
    ProductCarouselComponent.RIGHT = -23.75;
    return ProductCarouselComponent;
}());
export { ProductCarouselComponent };
